import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { ChevronLeft, User, Mail, Youtube } from 'lucide-react';
import { toast } from 'sonner';
import SiteHeaderV2 from '@/components/website/SiteHeaderV2';
import SiteFooterV2 from '@/components/website/SiteFooterV2';
import PageHeaderV2 from '@/components/website/PageHeaderV2';

/* eslint-disable react/no-unescaped-entities */

const ContactPage = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [sending, setSending] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSending(true);
    setTimeout(() => {
      toast.success("Message envoyé ! Je vous répondrai dans les plus brefs délais.");
      setFormData({ name: '', email: '', message: '' });
      setSending(false);
    }, 1000);
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: "#FFFFFF", fontFamily: "Figtree, sans-serif" }}>
      <SiteHeaderV2 />
      
      {/* Page Header Image */}
      <PageHeaderV2 
        title="Contact" 
        subtitle="N'hésitez pas à me contacter pour toute question"
      />
      
      {/* Hero */}
      <section className="py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <p className="text-xl text-slate-600">
            Vous avez des questions sur la rééducation respiratoire ? N'hésitez pas à me contacter.
          </p>
        </div>
      </section>

      {/* Contact Info & Form */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <div className="grid md:grid-cols-2 gap-12">
            {/* Info */}
            <div>
              <h2 className="text-2xl font-medium mb-6">Informations</h2>
              
              <div className="space-y-6">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-full bg-sky-100 flex items-center justify-center">
                    <User className="w-6 h-6 text-sky-600" />
                  </div>
                  <div>
                    <p className="font-medium">Julien Jaccard</p>
                    <p className="text-slate-600">Physiothérapeute, Suisse</p>
                  </div>
                </div>

                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-full bg-sky-100 flex items-center justify-center">
                    <Mail className="w-6 h-6 text-sky-600" />
                  </div>
                  <div>
                    <p className="font-medium">Email</p>
                    <a href="mailto:julienjaccard@mains-nuages.ch" className="text-sky-600 hover:underline">
                      julienjaccard@mains-nuages.ch
                    </a>
                  </div>
                </div>

                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-full bg-sky-100 flex items-center justify-center">
                    <Youtube className="w-6 h-6 text-sky-600" />
                  </div>
                  <div>
                    <p className="font-medium">YouTube</p>
                    <a href="https://youtube.com/@Jaccardjphysio" target="_blank" rel="noopener noreferrer" className="text-sky-600 hover:underline">
                      @Jaccardjphysio
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Form */}
            <div>
              <h2 className="text-2xl font-medium mb-6">Envoyer un message</h2>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <Label htmlFor="name">Nom</Label>
                  <Input
                    id="name"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    required
                    className="mt-1"
                  />
                </div>
                <div>
                  <Label htmlFor="email">Email</Label>
                  <Input
                    id="email"
                    type="email"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    required
                    className="mt-1"
                  />
                </div>
                <div>
                  <Label htmlFor="message">Message</Label>
                  <Textarea
                    id="message"
                    value={formData.message}
                    onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                    required
                    rows={5}
                    className="mt-1"
                  />
                </div>
                <Button type="submit" disabled={sending} className="w-full bg-cyan-500 hover:bg-cyan-600">
                  {sending ? "Envoi en cours..." : "Envoyer"}
                </Button>
              </form>
            </div>
          </div>
        </div>
      </section>

      <SiteFooterV2 />
    </div>
  );
};

export default ContactPage;
